module.exports = __webpack_public_path__ + "img/starcoach.a37aec11.png";